import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";

Vue.use(Vuex);

import { state, RootState } from "@/store/state";
import { mutations } from "@/store/mutations";
import { actions } from "@/store/actions";

import place from "@/store/place";

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store<RootState>({
    state,
    mutations,
    actions,
    modules: {
        vacan: {
            namespaced: true,
        },
        place,
    },
    strict: debug,
    plugins: debug ? [createLogger({})] : [],
});
